module.exports = __webpack_public_path__ + "static/media/IS6200.03736f6c.png";